export default [
    'ID',
    'Name'
]